var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68604 16.8701C4.17197 16.8701 0.459473 13.1998 0.459473 8.64355C0.459473 4.12949 4.12979 0.416992 8.68604 0.416992C13.2423 0.416992 16.9126 4.0873 16.9126 8.64355C16.8704 13.1998 13.2001 16.8701 8.68604 16.8701ZM8.68604 1.64043C4.80479 1.64043 1.64072 4.80449 1.64072 8.68574C1.64072 12.567 4.80479 15.7311 8.68604 15.7311C12.5673 15.7311 15.7313 12.567 15.7313 8.68574C15.6892 4.80449 12.5251 1.64043 8.68604 1.64043Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.655 20.5404L13.9175 14.8451L14.8456 13.917L20.5409 19.6545L19.655 20.5404Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBlack);
export default __webpack_public_path__ + "static/media/search-icon-black.55b0f7ecab2f98b3502f26928fd88ec9.svg";
export { ForwardRef as ReactComponent };